exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".goal-container{position:absolute;width:20px;height:20px}.goal-container .goal{width:12px;height:12px;margin:1px 0 0 9px;font-size:16px}@media (min-width:700px){.play-mode .goal-container{width:40px;height:40px}.play-mode .goal-container .goal{width:24px;height:24px;margin:5px 0 0 16px;font-size:32px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./styles/modules/goal.scss
// module id = 300
// module chunks = 0